import { render, staticRenderFns } from "./companyReports.vue?vue&type=template&id=0e587972&"
import script from "./companyReports.vue?vue&type=script&lang=js&"
export * from "./companyReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports